import { render, staticRenderFns } from "./CadastroFrete.vue?vue&type=template&id=59e85648&scoped=true&"
import script from "./CadastroFrete.vue?vue&type=script&lang=ts&"
export * from "./CadastroFrete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e85648",
  null
  
)

export default component.exports